import { LayersIcon, PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

export default function CreateBundleTile({ onClick, readOnly }) {
  const { t } = useTranslation();

  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <LayersIcon aria-hidden />
        </EmptyMedia>
        <EmptyTitle>{t('bundles.no_bundle_tile.title')}</EmptyTitle>
        <EmptyDescription>{t('bundles.no_bundle_tile.text')}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button size="sm" onClick={onClick} disabled={readOnly}>
          <PlusIcon size={16} />
          {t('common.create')}
        </Button>
      </EmptyContent>
    </Empty>
  );
}
